import { render, staticRenderFns } from "./DetailForm.vue?vue&type=template&id=ad54adc0&scoped=true"
import script from "./DetailForm.vue?vue&type=script&lang=ts"
export * from "./DetailForm.vue?vue&type=script&lang=ts"
import style0 from "./DetailForm.vue?vue&type=style&index=0&id=ad54adc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad54adc0",
  null
  
)

export default component.exports